import { ui } from '../../styles/ui'

export default function EmptyState({ title = 'No data', description, action }) {
  return (
    <div className={ui.states.empty}>
      <p className="font-semibold text-foreground">{title}</p>
      {description ? <p className="mt-1">{description}</p> : null}
      {action ? <div className="mt-3">{action}</div> : null}
    </div>
  )
}
